import React from "react";
import clsx from "clsx";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { EditableMathField } from "react-mathquill";
import Button from "../../../../../common/Button";

const AnswerEditor = ( props ) => {

  const answerEditor = useSelector( state => state.answerEditor );

  const { t } = useTranslation();

  return (
    <div className={ clsx( 'input_pop', answerEditor.isShow && 'on' ) }>
      <div className="head_wrap">
        <Button className="x" onClick={ props.onHide }><img src={ `${ process.env.PUBLIC_URL }/static/images/icon/keypad/ic_input_close.svg` } alt="" /></Button>
      </div>
      <div className="cont_wrap">
        <div className="write">
          <EditableMathField mathquillDidMount={ props.onMount } />
        </div>
      </div>
      <div className="foot_wrap">
        <Button onClick={ props.onReset }><span>{ t( "LC_02_06.msg010" ) }</span></Button>
        <Button className="check" onClick={ props.onSubmit }><span>{ t( "LC_02_06.msg009" ) }</span></Button>
      </div>
    </div>
  );

};

export default AnswerEditor;
